import { type BoxProgrammationLight } from "@modules/boxProgrammation/gateway/boxProgramDto"
import { type BoxSlotParticipation } from "@modules/boxSlot/boxSlotTypes"
import { UserEntity } from "@modules/profile/userProfile/userEntity"

export const Weekdays = {
  SUNDAY: "SUNDAY",
  MONDAY: "MONDAY",
  TUESDAY: "TUESDAY",
  WEDNESDAY: "WEDNESDAY",
  THURSDAY: "THURSDAY",
  FRIDAY: "FRIDAY",
  SATURDAY: "SATURDAY",
} as const
export type Weekdays = (typeof Weekdays)[keyof typeof Weekdays]

export const getWeekdayByIndex = (index: 0 | 1 | 2 | 3 | 4 | 5 | 6): Weekdays => {
  switch (index) {
    case 0:
      return Weekdays.SUNDAY
    case 1:
      return Weekdays.MONDAY
    case 2:
      return Weekdays.TUESDAY
    case 3:
      return Weekdays.WEDNESDAY
    case 4:
      return Weekdays.THURSDAY
    case 5:
      return Weekdays.FRIDAY
    case 6:
      return Weekdays.SATURDAY
    default: {
      const exhaustiveCheck: never = index
      throw new Error(`Invalid weekday index: ${String(exhaustiveCheck)}`)
    }
  }
}

export const getWeekdayValue = (weekDay: Weekdays) => {
  switch (weekDay) {
    case Weekdays.SUNDAY:
      return 0
    case Weekdays.MONDAY:
      return 1
    case Weekdays.TUESDAY:
      return 2
    case Weekdays.WEDNESDAY:
      return 3
    case Weekdays.THURSDAY:
      return 4
    case Weekdays.FRIDAY:
      return 5
    case Weekdays.SATURDAY:
      return 6
    default: {
      const exhaustiveCheck: never = weekDay
      throw new Error(`Invalid weekday: ${String(exhaustiveCheck)}`)
    }
  }
}

type ItemBoxSlotTemplateBase = {
  id?: string
  weekDay: string
  startTime: string
  endTime: string
  participantLimit: number | null
  location?: string
  participation?: BoxSlotParticipation
  allowMultiBooking?: boolean
  impactAlreadyCreatedSlot?: boolean
  program: BoxProgrammationLight
  assignedStaffMembers: UserEntity[]
  dropinsAccepted?: boolean
  trialsAccepted?: boolean
}

export type ItemBoxSlotTemplate = {
  id: string
} & ItemBoxSlotTemplateBase

export type BoxSlotTemplate = {
  id: string
  boxProgramId: string
} & ItemBoxSlotTemplateBase

export type BoxSlotTemplateDraft = Omit<ItemBoxSlotTemplateBase, "program">

export type BoxSlotsTemplateWeekPartial = {
  week: {
    MONDAY: ItemBoxSlotTemplate[]
    TUESDAY: ItemBoxSlotTemplate[]
    WEDNESDAY: ItemBoxSlotTemplate[]
    THURSDAY: ItemBoxSlotTemplate[]
    FRIDAY: ItemBoxSlotTemplate[]
    SATURDAY: ItemBoxSlotTemplate[]
    SUNDAY: ItemBoxSlotTemplate[]
  }
}

export type BoxSlotsTemplateWeek = {
  id: string
} & BoxSlotsTemplateWeekPartial
